// src/lib/prospects-api.js — client de l'endpoint /api/prospects (Lot 3,
// refondu LOT 4 OPÉRATEUR B : la file « À démarcher » de Logements).
//
// Le domaine PROSPECTS vit dans la table V2 via un endpoint admin-only. Le
// front charge via GET et mute via actions ciblées per-row. Erreurs serveur
// remontées.
//
// ⚠️ L'ancien `cleanup` (DELETE de masse « sans email NI tel ») et son
// comptage `countNonContactable` sont RETIRÉS. La purge se fait en DEUX temps
// liés par un MANDAT : `demarcherCountPurge` rend le compte ET les ids, et
// `demarcherPurge(ids)` ne peut supprimer que ceux-là (∩ recalcul serveur).
// Sans ce mandat, deux lectures séparées par l'écran de confirmation peuvent
// désigner deux populations différentes — et effacer plus que le nombre montré.
//
// ⚠️ SENTINELLE « jamais d'envoi seul » : aucune fonction demarcher* n'envoie
// quoi que ce soit — le brouillon revient au navigateur, l'humain copie/colle.

import { supabase } from '../supabase'

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

async function parseOrThrow(res, fallback) {
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || fallback)
  return json
}

export async function fetchProspects() {
  const res = await fetch('/api/prospects', { headers: await authHeaders() })
  return parseOrThrow(res, 'Lecture prospects échouée')
}

// { total, aRegarder } — zéro ligne, zéro PII (carte accueil + bascule Logements).
export async function fetchProspectsCount() {
  const res = await fetch('/api/prospects?action=count', { headers: await authHeaders() })
  return parseOrThrow(res, 'Comptage prospects échoué')
}

async function post(action, body) {
  const res = await fetch(`/api/prospects?action=${encodeURIComponent(action)}`, {
    method: 'POST',
    headers: await authHeaders(),
    body: JSON.stringify(body || {}),
  })
  return parseOrThrow(res, 'Opération prospects échouée')
}

export const prospectsApi = {
  fetchProspects,
  fetchProspectsCount,
  upsert: (prospect) => post('upsert', { prospect }),
  update: (id, patch) => post('update', { id, patch }),
  remove: (id) => post('delete', { id }),
  addInteraction: (id, interaction) => post('interaction', { id, interaction }),
  setStatut: (id, statut, interaction) => post('statut', { id, statut, interaction }),
  setMasque: (id, masque) => post('masque', { id, masque: masque === true }),
  // (`contactManuel` retiré : son seul appelant était « Copier », qui passe
  //  désormais par `demarcherCopie` — contact + statut en une mutation.
  //  L'action serveur `contact_manuel` reste disponible, gardée requireAdmin.)
  // LOT 4 B — la file « À démarcher » :
  demarcherCountPurge: () => post('demarcher_count_purge', {}),
  // `ids` = le mandat rendu par le comptage. Obligatoire (400 sinon).
  demarcherPurge: (ids) => post('demarcher_purge', { ids }),
  demarcherDraft: (id, opts) => post('demarcher_draft', { id, ...(opts || {}) }),
  demarcherAssigne: (id, assigne) => post('demarcher_assigne', { id, assigne: assigne || null }),
  // « Copier » : contacté + statut en UN appel (donc un seul miroir serveur).
  demarcherCopie: (id, champs) => post('demarcher_copie', { id, ...(champs || {}) }),
}
